import React, { useState, useEffect, useRef, useCallback } from 'react';
import './index.scss';

import {
    Carousel
} from 'antd';

import { useHistory } from 'react-router-dom';

function Home(props: any, ref: any) {
 
    const history = useHistory();

    const [type,setType] = useState(1);

    const [ companyList, setCompanyList ] = useState([]);
    const [ infoList, setInfoList ] = useState([]);

    const [ filesList, setFilesList ] = useState({});

    const [ files, setFiles ] = useState([]);

    const { getBidWinningCompanyList, getIndexPageInfo, getFilesList } = window.$axios.request;

    // let filesList = {
    //     "1": [
    //         {
    //             "url":"https://web-pro.998.com/files/格林酒店集团POS餐饮系统需求.pdf",
    //             "downloadName":"格林酒店集团POS餐饮系统需求.pdf",
    //             "name":"格林酒店集团POS餐饮系统需求"
    //         },
    //         {
    //             "url":"https://web-pro.998.com/files/《绿树下》2022-2023年度宣传册及台卡招标....zip",
    //             "downloadName":"《绿树下》2022-2023年度宣传册及台卡招标....zip",
    //             "name":"《绿树下》2022-2023年度宣传册及台卡招标..."
    //         },
    //         {
    //             "url":"https://web-pro.998.com/files/企业邮箱租赁服务需求与要求.pdf",
    //             "downloadName":"企业邮箱租赁服务需求与要求.pdf",
    //             "name":"企业邮箱租赁服务需求与要求"
    //         }
    //     ],
    //     "2": [
    //         {
    //             "url":"https://web-pro.998.com/files/格美集团鹿鹿咖啡·甜品·茶饮设计招标.zip",
    //             "downloadName":"格美集团鹿鹿咖啡·甜品·茶饮设计招标.zip",
    //             "name":"格美集团鹿鹿咖啡·甜品·茶饮设计招标"
    //         }
    //     ],
    //     "3": [
    //         {
    //             "url":"https://web-pro.998.com/files/中山北路格菲酒店配套用房装修改造工程V2.zip",
    //             "downloadName":"中山北路格菲酒店配套用房装修改造工程V2.zip",
    //             "name":"中山北路格菲酒店配套用房装修改造工程V2"
    //         }
    //     ]
    // }

    useEffect(() => {
        getBidWinningCompanyList()
        .then((res:any) => {
            if(res.code == 1000){
                setCompanyList(res.data)
            }
        })

        _getIndexPageInfo(1);
        // _getFilesList();
    },[])

    const _getIndexPageInfo = (_type:number) => {
        getIndexPageInfo({},{bidType: _type,})
        .then((res:any) => {
            if(res.code == 1000){
                setInfoList(res.data)
            }
        })
    }

    const _getFilesList = () => {
        getFilesList()
        .then((res:any) => {
            setFilesList(res);
            setFiles(res[1]);
        })
    }

    const End = () => {
        return <div className='end'>
            <div className='content'>
                <div className='title'>
                    <div className='texts'>到底啦
                        <div className='left'></div>
                        <div className='right'></div>
                    </div>
                </div>
            </div>
            
        </div>
    }

    const FileDownload = () => {
        return <div className='file-download'>
            <div className='content'>
                <div className='title'>
                    <div className='texts'>附件下载
                        <div className='left'></div>
                        <div className='right'></div>
                    </div>
                </div>
                <div className='describe'>我司确定需要实施设计项目后，将联系符合条件的有意向企业进行进一步沟通。</div>
                <div className='file-lists'>
                    <div className='header ub ub-space-between'>
                        <div className='left'>文件名</div>
                    </div>
                    {
                        files.map((item:any,index:number) => {
                            return <div className='file-list ub ub-space-between' key={index}>
                                <div className='left'>
                                    <img className='banner-img' src={require("../../assets/images/fujian.png")} alt="" />
                                    <a href={item.url} download={item.downloadName} target="_blank">{item.name}</a>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    }

    const ContactUs = () => {
        return <div className='contact-us'>
            <div className='content'>
                <div className='title'>
                    <div className='texts'>联系我们
                        <div className='left'></div>
                        <div className='right'></div>
                    </div>
                </div>
                {
                    type == 1 && <div className='way ub'>
                        <div className='left'>
                            <img className='banner-img' src={require("../../assets/images/p1.png")} alt="" />
                        </div>
                        <div className='right'>
                            <div className='contact-title'>采购招标</div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/1.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>联系人</div>
                                    <div className='contact-text2'>采购部</div>
                                </div>
                            </div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/2.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>电话</div>
                                    <div className='contact-text3'><a href="tel:0213617">021-3617  4886转7005</a></div>
                                </div>
                            </div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/3.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>邮箱</div>
                                    <div className='contact-text3'><a href="mailto:caigou@998.com">caigou@998.com</a></div>
                                </div>
                            </div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/4.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>采购平台</div>
                                    <div className='contact-text3'><a href="https://www.168.com" target="_blank">www.168.com</a></div>
                                    <div className='contact-text2'>可登录我司采购平台：“酒店采购专区”给我司留下您的宝贵意见。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    type == 2 && <div className='way ub'>
                        <div className='left'>
                            <img className='banner-img' src={require("../../assets/images/p2.png")} alt="" />
                        </div>
                        <div className='right'>
                            <div className='contact-title'>设计招标</div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/1.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>联系人</div>
                                    <div className='contact-text2'>设计标准部</div>
                                </div>
                            </div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/2.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>电话</div>
                                    <div className='contact-text3'><a href="tel:0213617">021-3617  4886转6329</a></div>
                                </div>
                            </div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/3.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>邮箱</div>
                                    <div className='contact-text3'><a href="mailto:gcwzcg@998.com">gcwzcg@998.com</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    type == 3 && <div className='way ub'>
                        <div className='left'>
                            <img className='banner-img' src={require("../../assets/images/p3.png")} alt="" />
                        </div>
                        <div className='right'>
                            <div className='contact-title'>工程招标</div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/1.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>联系人</div>
                                    <div className='contact-text2'>工程部</div>
                                </div>
                            </div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/2.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>电话</div>
                                    <div className='contact-text3'><a href="tel:0213617">021-3617  4886转6226</a></div>
                                </div>
                            </div>
                            <div className='contact-infor ub'>
                                <div className='contact-icon'><img src={require("../../assets/images/3.png")} alt="" /></div>
                                <div>
                                    <div className='contact-text1'>邮箱</div>
                                    <div className='contact-text3'><a href="mailto:gcwzcg@998.com">gcwzcg@998.com</a></div>
                                </div>
                            </div>
                            <div className='contact-title2'>具体要求</div>
                            <div className='contact-infor ub'>
                                <div>
                                    <div className='contact-text2'>1. 装饰一级资质（优先考虑国企、上市公司）</div>
                                    <div className='contact-text2'>2. 2年内连锁酒店工程业绩</div>
                                    <div className='contact-text2'>3. 现场管理人员资质（包括项目经理从业资格证书、业绩）</div>
                                    <div className='contact-text2'>请将以上内容及设备、资金等资质信息发送至工程部邮箱。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    }

    const Infomation = () => {
        return <div className='informations'>
            <div className='content'>
                <div className='tabs ub ub-space-between'>
                    <div className={`cursor-pointer ${type == 1?"actived":""}`} onClick={() => {setType(1);_getIndexPageInfo(1)}}>采购招标信息</div>
                    <div className={`cursor-pointer ${type == 2?"actived":""}`} onClick={() => {setType(2);_getIndexPageInfo(2)}}>设计招标信息</div>
                    <div className={`cursor-pointer ${type == 3?"actived":""}`} onClick={() => {setType(3);_getIndexPageInfo(3)}}>工程招标信息</div>
                </div>
                <div className='information-lists'>
                    <div className='information-list'>
                        <div className='title'>
                            <div className='texts'><span className='name-color'>{type == 1?"采购":type == 2?"设计":"工程"}</span>招标信息
                                <div className='left'></div>
                                <div className='right'></div>
                            </div>
                        </div>
                        <div className='lists ub'>
                            {
                                infoList.map((item:any,index:number) => {
                                    return <div className='list ub ub-column ub-space-between' key={index}
                                    onClick={(e) => {
                                        window.open(item.mainBody);
                                    }}
                                    >
                                        <div className='top cut-2'>{item.mainTitle}</div>
                                        {
                                            item.attachmentBody && <div className='attachment'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    window.open(item.attachmentBody);
                                                }}
                                            >
                                                <img className='banner-img' src={require("../../assets/images/fujian2.png")} alt="" />
                                                下载附件
                                            </div>
                                        }
                                        <div className='bottom ub ub-space-between'>
                                            <div className='time'>{item.beginDate}至{item.endDate}</div>
                                            <div className='toDetail cursor-pointer'>
                                                {"查看详情 >>"}
                                                {/* <a href={item.mainBody} target="_blank">{"查看详情 >>"}</a> */}
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                        <div className='history cursor-pointer' onClick={() => {window.open(window.location.href+`history?type=${type}`)}}>{"查看历史招标信息>>"}</div>
                    </div>
                </div>
            </div>
        </div>
    }

    const Banner = () => {
        return <div className='banner'>
            <div className='banner-img'>
                {/* <img className='banner-img' src={require("../../assets/images/banner-short.png")} alt="" /> */}
            </div>
            {
                companyList.length > 0 && <div className='carousel ub '>
                    <div className='notice-img'><img src={require("../../assets/images/notice.png")} alt="" /></div>
                    <div className='carousel-lists'>
                        <Carousel autoplay autoplaySpeed={5000} dotPosition={"left"} dots={false}>
                            {/* <div className='carousel-list' >{`恭喜 255`} <span className='high'>中标</span> 151515</div> */}
                            {
                                companyList.map((item:any,index:number) => {
                                    return <div className='carousel-list' key={index}>{`恭喜 ${item.companyName}`} <span className='high'>中标</span> {`${item.mainTitle}`}</div>
                                })
                            }
                            {/* <div className='carousel-list'>111</div> */}
                        </Carousel>
                    </div>
                </div>
            }
        </div>
    }

    return (
        <div className="bidding">
            {Banner()}
            {Infomation()}
            {ContactUs()}
            {/* {FileDownload()} */}
            {End()}
        </div>
    )
}
export default Home;